/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { InlineObjectDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityDefinitionDetailDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityDefinitionDocumentDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityDefinitionDocumentsResponseDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityDefinitionListResponseDto } from '../models';
// @ts-ignore
import type { ProfessionalActivityDefinitionSortByDto } from '../models';
// @ts-ignore
import type { SortDirectionDto } from '../models';
// @ts-ignore
import type { ToggleDefinitionAiContextRequestDto } from '../models';
// @ts-ignore
import type { UpdateProfessionalActivityDefinitionRequestDto } from '../models';
/**
 * ProfessionalActivityDefinitionsApi - axios parameter creator
 * @export
 */
export const ProfessionalActivityDefinitionsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Removes the file from S3 and its metadata row. Requires professional.activity.definition.write.
         * @summary Delete a file attached to a definition (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfessionalActivityDefinitionDocument: async (definitionId: number, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('deleteProfessionalActivityDefinitionDocument', 'definitionId', definitionId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('deleteProfessionalActivityDefinitionDocument', 'documentId', documentId)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}/documents/{documentId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary Get a professional activity definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinition: async (definitionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('getProfessionalActivityDefinition', 'definitionId', definitionId)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary List files attached to a definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinitionDocuments: async (definitionId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('getProfessionalActivityDefinitionDocuments', 'definitionId', definitionId)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}/documents`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Paginated, sortable, searchable list. Requires professional.activity.definition.read.
         * @summary List professional activity definitions (admin)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by name (partial, case-insensitive)
         * @param {ProfessionalActivityDefinitionSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinitions: async (page?: number, pageSize?: number, search?: string, sortBy?: ProfessionalActivityDefinitionSortByDto, sortOrder?: SortDirectionDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/admin/professional-activity-definitions`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sortBy !== undefined) {
                localVarQueryParameter['sortBy'] = sortBy;
            }

            if (sortOrder !== undefined) {
                localVarQueryParameter['sortOrder'] = sortOrder;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Clears the document\'s chat vectors and re-runs extraction + embedding (async). Requires professional.activity.definition.write.
         * @summary Re-extract and re-embed a definition document (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reembedProfessionalActivityDefinitionDocument: async (definitionId: number, documentId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('reembedProfessionalActivityDefinitionDocument', 'definitionId', definitionId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('reembedProfessionalActivityDefinitionDocument', 'documentId', documentId)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}/documents/{documentId}/reembed`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * When turned on the document is (re)embedded; when turned off its vectors are removed. Requires professional.activity.definition.write.
         * @summary Toggle whether a definition document is AI chat context (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {ToggleDefinitionAiContextRequestDto} toggleDefinitionAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleProfessionalActivityDefinitionDocumentAiContext: async (definitionId: number, documentId: number, toggleDefinitionAiContextRequestDto: ToggleDefinitionAiContextRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('toggleProfessionalActivityDefinitionDocumentAiContext', 'definitionId', definitionId)
            // verify required parameter 'documentId' is not null or undefined
            assertParamExists('toggleProfessionalActivityDefinitionDocumentAiContext', 'documentId', documentId)
            // verify required parameter 'toggleDefinitionAiContextRequestDto' is not null or undefined
            assertParamExists('toggleProfessionalActivityDefinitionDocumentAiContext', 'toggleDefinitionAiContextRequestDto', toggleDefinitionAiContextRequestDto)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}/documents/{documentId}/ai-context`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)))
                .replace(`{${"documentId"}}`, encodeURIComponent(String(documentId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(toggleDefinitionAiContextRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Only the description is editable; the name is read-only. Requires professional.activity.definition.write.
         * @summary Update the description of a definition (admin)
         * @param {number} definitionId 
         * @param {UpdateProfessionalActivityDefinitionRequestDto} updateProfessionalActivityDefinitionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfessionalActivityDefinition: async (definitionId: number, updateProfessionalActivityDefinitionRequestDto: UpdateProfessionalActivityDefinitionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('updateProfessionalActivityDefinition', 'definitionId', definitionId)
            // verify required parameter 'updateProfessionalActivityDefinitionRequestDto' is not null or undefined
            assertParamExists('updateProfessionalActivityDefinition', 'updateProfessionalActivityDefinitionRequestDto', updateProfessionalActivityDefinitionRequestDto)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(updateProfessionalActivityDefinitionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * File is stored in S3; the row holds only metadata + S3 key. Requires professional.activity.definition.write.
         * @summary Upload a file and attach it to a definition (admin)
         * @param {number} definitionId 
         * @param {File} file File to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfessionalActivityDefinitionDocument: async (definitionId: number, file: File, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'definitionId' is not null or undefined
            assertParamExists('uploadProfessionalActivityDefinitionDocument', 'definitionId', definitionId)
            // verify required parameter 'file' is not null or undefined
            assertParamExists('uploadProfessionalActivityDefinitionDocument', 'file', file)
            const localVarPath = `/api/v1/admin/professional-activity-definitions/{definitionId}/documents`
                .replace(`{${"definitionId"}}`, encodeURIComponent(String(definitionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;
            const localVarFormParams = new ((configuration && configuration.formDataCtor) || FormData)();


            if (file !== undefined) { 
                localVarFormParams.append('file', file as any);
            }
    
    
            localVarHeaderParameter['Content-Type'] = 'multipart/form-data';
    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = localVarFormParams;

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ProfessionalActivityDefinitionsApi - functional programming interface
 * @export
 */
export const ProfessionalActivityDefinitionsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ProfessionalActivityDefinitionsApiAxiosParamCreator(configuration)
    return {
        /**
         * Removes the file from S3 and its metadata row. Requires professional.activity.definition.write.
         * @summary Delete a file attached to a definition (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async deleteProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.deleteProfessionalActivityDefinitionDocument(definitionId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.deleteProfessionalActivityDefinitionDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary Get a professional activity definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfessionalActivityDefinition(definitionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityDefinitionDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfessionalActivityDefinition(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.getProfessionalActivityDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary List files attached to a definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfessionalActivityDefinitionDocuments(definitionId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityDefinitionDocumentsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfessionalActivityDefinitionDocuments(definitionId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.getProfessionalActivityDefinitionDocuments']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Paginated, sortable, searchable list. Requires professional.activity.definition.read.
         * @summary List professional activity definitions (admin)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by name (partial, case-insensitive)
         * @param {ProfessionalActivityDefinitionSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProfessionalActivityDefinitions(page?: number, pageSize?: number, search?: string, sortBy?: ProfessionalActivityDefinitionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityDefinitionListResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProfessionalActivityDefinitions(page, pageSize, search, sortBy, sortOrder, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.getProfessionalActivityDefinitions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Clears the document\'s chat vectors and re-runs extraction + embedding (async). Requires professional.activity.definition.write.
         * @summary Re-extract and re-embed a definition document (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reembedProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reembedProfessionalActivityDefinitionDocument(definitionId, documentId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.reembedProfessionalActivityDefinitionDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * When turned on the document is (re)embedded; when turned off its vectors are removed. Requires professional.activity.definition.write.
         * @summary Toggle whether a definition document is AI chat context (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {ToggleDefinitionAiContextRequestDto} toggleDefinitionAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async toggleProfessionalActivityDefinitionDocumentAiContext(definitionId: number, documentId: number, toggleDefinitionAiContextRequestDto: ToggleDefinitionAiContextRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.toggleProfessionalActivityDefinitionDocumentAiContext(definitionId, documentId, toggleDefinitionAiContextRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.toggleProfessionalActivityDefinitionDocumentAiContext']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Only the description is editable; the name is read-only. Requires professional.activity.definition.write.
         * @summary Update the description of a definition (admin)
         * @param {number} definitionId 
         * @param {UpdateProfessionalActivityDefinitionRequestDto} updateProfessionalActivityDefinitionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateProfessionalActivityDefinition(definitionId: number, updateProfessionalActivityDefinitionRequestDto: UpdateProfessionalActivityDefinitionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityDefinitionDetailDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateProfessionalActivityDefinition(definitionId, updateProfessionalActivityDefinitionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.updateProfessionalActivityDefinition']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * File is stored in S3; the row holds only metadata + S3 key. Requires professional.activity.definition.write.
         * @summary Upload a file and attach it to a definition (admin)
         * @param {number} definitionId 
         * @param {File} file File to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async uploadProfessionalActivityDefinitionDocument(definitionId: number, file: File, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ProfessionalActivityDefinitionDocumentDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.uploadProfessionalActivityDefinitionDocument(definitionId, file, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ProfessionalActivityDefinitionsApi.uploadProfessionalActivityDefinitionDocument']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ProfessionalActivityDefinitionsApi - factory interface
 * @export
 */
export const ProfessionalActivityDefinitionsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ProfessionalActivityDefinitionsApiFp(configuration)
    return {
        /**
         * Removes the file from S3 and its metadata row. Requires professional.activity.definition.write.
         * @summary Delete a file attached to a definition (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.deleteProfessionalActivityDefinitionDocument(definitionId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary Get a professional activity definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinition(definitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDetailDto> {
            return localVarFp.getProfessionalActivityDefinition(definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Requires professional.activity.definition.read.
         * @summary List files attached to a definition (admin)
         * @param {number} definitionId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinitionDocuments(definitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDocumentsResponseDto> {
            return localVarFp.getProfessionalActivityDefinitionDocuments(definitionId, options).then((request) => request(axios, basePath));
        },
        /**
         * Paginated, sortable, searchable list. Requires professional.activity.definition.read.
         * @summary List professional activity definitions (admin)
         * @param {number} [page] 
         * @param {number} [pageSize] 
         * @param {string} [search] Filter by name (partial, case-insensitive)
         * @param {ProfessionalActivityDefinitionSortByDto} [sortBy] 
         * @param {SortDirectionDto} [sortOrder] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProfessionalActivityDefinitions(page?: number, pageSize?: number, search?: string, sortBy?: ProfessionalActivityDefinitionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionListResponseDto> {
            return localVarFp.getProfessionalActivityDefinitions(page, pageSize, search, sortBy, sortOrder, options).then((request) => request(axios, basePath));
        },
        /**
         * Clears the document\'s chat vectors and re-runs extraction + embedding (async). Requires professional.activity.definition.write.
         * @summary Re-extract and re-embed a definition document (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reembedProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.reembedProfessionalActivityDefinitionDocument(definitionId, documentId, options).then((request) => request(axios, basePath));
        },
        /**
         * When turned on the document is (re)embedded; when turned off its vectors are removed. Requires professional.activity.definition.write.
         * @summary Toggle whether a definition document is AI chat context (admin)
         * @param {number} definitionId 
         * @param {number} documentId 
         * @param {ToggleDefinitionAiContextRequestDto} toggleDefinitionAiContextRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        toggleProfessionalActivityDefinitionDocumentAiContext(definitionId: number, documentId: number, toggleDefinitionAiContextRequestDto: ToggleDefinitionAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.toggleProfessionalActivityDefinitionDocumentAiContext(definitionId, documentId, toggleDefinitionAiContextRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * Only the description is editable; the name is read-only. Requires professional.activity.definition.write.
         * @summary Update the description of a definition (admin)
         * @param {number} definitionId 
         * @param {UpdateProfessionalActivityDefinitionRequestDto} updateProfessionalActivityDefinitionRequestDto 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateProfessionalActivityDefinition(definitionId: number, updateProfessionalActivityDefinitionRequestDto: UpdateProfessionalActivityDefinitionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDetailDto> {
            return localVarFp.updateProfessionalActivityDefinition(definitionId, updateProfessionalActivityDefinitionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * File is stored in S3; the row holds only metadata + S3 key. Requires professional.activity.definition.write.
         * @summary Upload a file and attach it to a definition (admin)
         * @param {number} definitionId 
         * @param {File} file File to attach
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        uploadProfessionalActivityDefinitionDocument(definitionId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDocumentDto> {
            return localVarFp.uploadProfessionalActivityDefinitionDocument(definitionId, file, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ProfessionalActivityDefinitionsApi - interface
 * @export
 * @interface ProfessionalActivityDefinitionsApi
 */
export interface ProfessionalActivityDefinitionsApiInterface {
    /**
     * Removes the file from S3 and its metadata row. Requires professional.activity.definition.write.
     * @summary Delete a file attached to a definition (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    deleteProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Requires professional.activity.definition.read.
     * @summary Get a professional activity definition (admin)
     * @param {number} definitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    getProfessionalActivityDefinition(definitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDetailDto>;

    /**
     * Requires professional.activity.definition.read.
     * @summary List files attached to a definition (admin)
     * @param {number} definitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    getProfessionalActivityDefinitionDocuments(definitionId: number, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDocumentsResponseDto>;

    /**
     * Paginated, sortable, searchable list. Requires professional.activity.definition.read.
     * @summary List professional activity definitions (admin)
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by name (partial, case-insensitive)
     * @param {ProfessionalActivityDefinitionSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    getProfessionalActivityDefinitions(page?: number, pageSize?: number, search?: string, sortBy?: ProfessionalActivityDefinitionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionListResponseDto>;

    /**
     * Clears the document\'s chat vectors and re-runs extraction + embedding (async). Requires professional.activity.definition.write.
     * @summary Re-extract and re-embed a definition document (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    reembedProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * When turned on the document is (re)embedded; when turned off its vectors are removed. Requires professional.activity.definition.write.
     * @summary Toggle whether a definition document is AI chat context (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {ToggleDefinitionAiContextRequestDto} toggleDefinitionAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    toggleProfessionalActivityDefinitionDocumentAiContext(definitionId: number, documentId: number, toggleDefinitionAiContextRequestDto: ToggleDefinitionAiContextRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * Only the description is editable; the name is read-only. Requires professional.activity.definition.write.
     * @summary Update the description of a definition (admin)
     * @param {number} definitionId 
     * @param {UpdateProfessionalActivityDefinitionRequestDto} updateProfessionalActivityDefinitionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    updateProfessionalActivityDefinition(definitionId: number, updateProfessionalActivityDefinitionRequestDto: UpdateProfessionalActivityDefinitionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDetailDto>;

    /**
     * File is stored in S3; the row holds only metadata + S3 key. Requires professional.activity.definition.write.
     * @summary Upload a file and attach it to a definition (admin)
     * @param {number} definitionId 
     * @param {File} file File to attach
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApiInterface
     */
    uploadProfessionalActivityDefinitionDocument(definitionId: number, file: File, options?: RawAxiosRequestConfig): AxiosPromise<ProfessionalActivityDefinitionDocumentDto>;

}

/**
 * ProfessionalActivityDefinitionsApi - object-oriented interface
 * @export
 * @class ProfessionalActivityDefinitionsApi
 * @extends {BaseAPI}
 */
export class ProfessionalActivityDefinitionsApi extends BaseAPI implements ProfessionalActivityDefinitionsApiInterface {
    /**
     * Removes the file from S3 and its metadata row. Requires professional.activity.definition.write.
     * @summary Delete a file attached to a definition (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public deleteProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).deleteProfessionalActivityDefinitionDocument(definitionId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires professional.activity.definition.read.
     * @summary Get a professional activity definition (admin)
     * @param {number} definitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public getProfessionalActivityDefinition(definitionId: number, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).getProfessionalActivityDefinition(definitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Requires professional.activity.definition.read.
     * @summary List files attached to a definition (admin)
     * @param {number} definitionId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public getProfessionalActivityDefinitionDocuments(definitionId: number, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).getProfessionalActivityDefinitionDocuments(definitionId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Paginated, sortable, searchable list. Requires professional.activity.definition.read.
     * @summary List professional activity definitions (admin)
     * @param {number} [page] 
     * @param {number} [pageSize] 
     * @param {string} [search] Filter by name (partial, case-insensitive)
     * @param {ProfessionalActivityDefinitionSortByDto} [sortBy] 
     * @param {SortDirectionDto} [sortOrder] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public getProfessionalActivityDefinitions(page?: number, pageSize?: number, search?: string, sortBy?: ProfessionalActivityDefinitionSortByDto, sortOrder?: SortDirectionDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).getProfessionalActivityDefinitions(page, pageSize, search, sortBy, sortOrder, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Clears the document\'s chat vectors and re-runs extraction + embedding (async). Requires professional.activity.definition.write.
     * @summary Re-extract and re-embed a definition document (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public reembedProfessionalActivityDefinitionDocument(definitionId: number, documentId: number, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).reembedProfessionalActivityDefinitionDocument(definitionId, documentId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * When turned on the document is (re)embedded; when turned off its vectors are removed. Requires professional.activity.definition.write.
     * @summary Toggle whether a definition document is AI chat context (admin)
     * @param {number} definitionId 
     * @param {number} documentId 
     * @param {ToggleDefinitionAiContextRequestDto} toggleDefinitionAiContextRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public toggleProfessionalActivityDefinitionDocumentAiContext(definitionId: number, documentId: number, toggleDefinitionAiContextRequestDto: ToggleDefinitionAiContextRequestDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).toggleProfessionalActivityDefinitionDocumentAiContext(definitionId, documentId, toggleDefinitionAiContextRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Only the description is editable; the name is read-only. Requires professional.activity.definition.write.
     * @summary Update the description of a definition (admin)
     * @param {number} definitionId 
     * @param {UpdateProfessionalActivityDefinitionRequestDto} updateProfessionalActivityDefinitionRequestDto 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public updateProfessionalActivityDefinition(definitionId: number, updateProfessionalActivityDefinitionRequestDto: UpdateProfessionalActivityDefinitionRequestDto, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).updateProfessionalActivityDefinition(definitionId, updateProfessionalActivityDefinitionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * File is stored in S3; the row holds only metadata + S3 key. Requires professional.activity.definition.write.
     * @summary Upload a file and attach it to a definition (admin)
     * @param {number} definitionId 
     * @param {File} file File to attach
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ProfessionalActivityDefinitionsApi
     */
    public uploadProfessionalActivityDefinitionDocument(definitionId: number, file: File, options?: RawAxiosRequestConfig) {
        return ProfessionalActivityDefinitionsApiFp(this.configuration).uploadProfessionalActivityDefinitionDocument(definitionId, file, options).then((request) => request(this.axios, this.basePath));
    }
}

